import { useMemo } from 'react';
import { JustfiIntegration1 } from '@frontend/api-justifi-integration';

export type UseJustifiBusinessDataProps = {
  locationId?: string;
};
export const useJustifiBusinessData = ({ locationId }: UseJustifiBusinessDataProps) => {
  /**
   * Attempt to load the business data as soon as we have a location ID.
   */
  const {
    data: business,
    isFetched: isFetchedGet,
    isLoading,
    refetch: refetchGet,
  } = JustfiIntegration1.Queries.useGetMerchantConnectionQuery({
    request: {
      locationId,
    },
    options: {
      enabled: !!locationId,
      retry: false,
    },
  });

  /**
   * If the GetMerchant (above) is fetched and returned no results,
   * create a business and then refetch the GetMerchant query.
   */
  const { data: createData } = JustfiIntegration1.Queries.useCreateMerchantConnectionQuery({
    request: {
      locationId,
    },
    options: {
      enabled: isFetchedGet && !business,
      onSuccess: () => {
        refetchGet();
      },
    },
  });

  /**
   * Many places, we just need the business ID to begin querying the auth token.
   * This saves precious miliseconds.
   */
  const businessId = useMemo(() => {
    return business?.businessId || createData?.businessId;
  }, [business, createData]);

  return {
    businessId,
    business,
    isLoading: isLoading || !isFetchedGet,
  };
};
